import {http} from "../config/Constantes";

export default class DivisaoService {
    constructor() {}

    list() {
        return http.get("/divisao");
    }

    listByPrefixoNome(nome) {
        return http.get(`/divisao/prefixo/${encodeURIComponent(nome)}`);
    }
}
